<script>
    /*
	    ReviewFetchPanel.svelte
    */

    import { onMount } from 'svelte';
    import { REVIEW_CREATE, REVIEW_UPDATE, REVIEW_MERGE } from '../../common/constants.js';

    // TCARE components

    // SMUI components
    import Button, { Label } from '@smui/button';
    // import Select, { Option } from '@smui/select';
    import Checkbox from '@smui/checkbox';

    // 8/25 - props passed in from the ReviewPage
    export let fetchCount;
    export let fetchType;
    export let fetchMostRecent;
    export let onFetchReviews;

    $: isShowingFilters = false;

    const reviewFilters = {
        isAdmin: false,
        isAuthUser: false,
        isWithFlags: false,
        isWithoutFlags: false,
        isOnlyApproved: false,
        isWaitingApproval: false
    }

    onMount(() => {
    })

    // 9/19 - may have to include filter options now
    const _onFetchReviews = (type) => {
        fetchType = type;                           // bound prop on ReviewPage
        // get filter options?
        if (onFetchReviews) onFetchReviews();       // on ReviewPage - no params now
    }

    
</script>

<style>
    .review-fetch-panel {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;
        /* border: 1px solid red; */
    }

    :global(.review-fetch-panel .mdc-button) {
        min-width: 160px !important;
        margin-right: 20px;
        border-radius: 18px;
        overflow: hidden;
    }

    .review-fetch-panel select {
        width: 80px;
        padding: 5px;
        border: none;
        border-bottom: 1px solid #F1EFF1;
        font-size: 16px;
    }

    .review-fetch-panel .select-row {
        margin-top: -50px;
    }   

    .review-fetch-panel .fetch-count {
        margin-left: 46px;
    }

    .filter-options-panel {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 20px;
        /* border: 1px solid green; */
    }

    /* make this a component? */
    .filter-options-block {
        width: 100%;
        width: 200px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
    }

    .option-title {
        font-weight: 800;
        text-transform: uppercase;
    }

    /* align the SMUI controls under the titles */
    .checkbox-row {
        margin-bottom: -10px;
        margin-left: -13px;
        justify-content: flex-start;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- changing fetchCount is bound to the ReviewPage prop -->

<div class="review-fetch-panel">
    <div class="flex-row select-row jc-start">
        <div class="fetch-count">How many reviews would you like to fetch?</div>
        <select class="count-select" bind:value={fetchCount}>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
        </select>
    </div>
    <div class="flex-row button-row jc-start">
        <div class="fetch-count">Would you like to fetch the most recently submitted reviews?</div>
        <select class="count-select" bind:value={fetchMostRecent}>
            <option value={true}>yes</option>
            <option value={false}>no</option>
        </select>
    </div>

    <div class="spacer-h-50"></div>
    <div class="flex-row button-row jc-between">

        <div class="flex-row jc-start">
            <Button 
                color="primary" 
                on:click={() => _onFetchReviews(REVIEW_CREATE)}
                variant="outlined"
            >
                <Label>Fetch CREATES</Label>
            </Button>
            <Button
                color="primary" 
                on:click={() => _onFetchReviews(REVIEW_UPDATE)} 
                variant="outlined"
            >
                <Label>Fetch UPDATES</Label>
            </Button>
            <Button
                color="primary" 
                on:click={() => _onFetchReviews(REVIEW_MERGE)} 
                variant="outlined"
            >
                <Label>Fetch MERGES</Label>
            </Button>
        </div>

        <!-- TODO: add Review filters once Connor is ready -->
        <!--
        <Button
            color="primary" 
            on:click={() => isShowingFilters = !isShowingFilters} 
            variant="outlined"
            style={'margin-right: 0px'}
        >
            {#if isShowingFilters}
                <Label>Hide Filters</Label>
            {:else}
                <Label>Show Filters</Label>
            {/if}
        </Button>
        -->

    </div>

    {#if isShowingFilters}
        <div class="filter-options-panel">
            <div class="filter-options-block">
                <div class="option-title">Display by Submitter</div>
                <div class="flex-row jc-start checkbox-row">
                    <Checkbox bind:checked={reviewFilters.isAdmin} />Administrator
                </div>
                <div class="flex-row checkbox-row">
                    <Checkbox bind:checked={reviewFilters.isAuthUser} />Authorized Users
                </div>        
            </div>
            <div class="filter-options-block">
                <div class="option-title">Flags</div>
                <div class="flex-row checkbox-row">
                    <Checkbox bind:checked={reviewFilters.isWithFlags} />Reviews with Flags
                </div>
                <div class="flex-row checkbox-row">
                    <Checkbox bind:checked={reviewFilters.isWithoutFlags} />Reviews without Flags
                </div>        
            </div>
            <div class="filter-options-block">
                <div class="option-title">Status</div>
                <div class="flex-row checkbox-row">
                    <Checkbox bind:checked={reviewFilters.isOnlyApproved} />Only Approved
                </div>
                <div class="flex-row checkbox-row">
                    <Checkbox bind:checked={reviewFilters.isWaitingApproval} />Waiting for Approval
                </div>        
            </div>
        </div>
    {/if}
</div>
